import styles from "../../styles/pages/Restaurant.module.scss"
import Slider from "react-slick";
import { useState } from 'react';
import Gallerymodal from "../Gallerymodal/Gallerymodal";

export default function Restaurantgallery() {
    const [clickedImage, setClickedImage] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);

    const gallery_slider = {
        centerMode: true,
        dots: true,
        infinite: true,
        // centerPadding: "60px",
        arrows: true,
        speed: 500,
        slidesToShow: 2.3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.4,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const galleryImages = [
        {
            bgImage: "/images/Gallery/img-1.jpg",
        },
        {
            bgImage: "/images/Gallery/img-2.jpg",
        },
        {
            bgImage: "/images/Gallery/img-3.jpg",
        },
        {
            bgImage: "/images/Gallery/img-5.jpg",
        },
        {
            bgImage: "/images/Gallery/img-6.jpg",
        },
        {
            bgImage: "/images/Gallery/img-8.jpg",
        },
        {
            bgImage: "/images/Gallery/img-9.jpg",
        },
        {
            bgImage: "/images/Gallery/img-10.jpg",
        },
    ]

    const handleClick = (item, index) => {
        setCurrentIndex(index);
        setClickedImage(item.bgImage)
    }

    return (
        <>
            <section className={`${styles.restaurant_gal} common_padding`} id="popular_dishes">
                <Slider {...gallery_slider} className="gallery_slider">
                    {galleryImages.map((item, index) => (
                        <div className={styles.gallery_child} key={index} onClick={() => handleClick(item, index)}>
                            <img src={item.bgImage} onClick={() => handleClick(item, index)} alt={`Food Image ${index + 1}`} />
                        </div>
                    ))}
                </Slider>
                {clickedImage && (
                    <Gallerymodal
                        galleryImages={galleryImages}
                        currentIndex={currentIndex}
                        setClickedImage={setClickedImage}
                    />
                )}
            </section>
        </>
    )
}
